"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storefrontVisited = void 0;
const constants_1 = require("../constants");
exports.storefrontVisited = ({ session, storefront, cart, }) => {
    const cartProps = cart
        ? {
            [constants_1.EventProperty.CART_PRODUCT_CATEGORIES]: cart.categories,
            [constants_1.EventProperty.CART_PRODUCT_IDS]: cart.ids,
            [constants_1.EventProperty.CART_PRODUCT_NAMES]: cart.names,
            [constants_1.EventProperty.CART_PRODUCT_SKUS]: cart.skus,
            [constants_1.EventProperty.CART_SIZE]: cart.size,
            [constants_1.EventProperty.CART_VALUE]: cart.value,
            [constants_1.EventProperty.PRELOADED_CART_TYPE]: cart.preloadedType,
        }
        : {};
    const props = {
        [constants_1.EventProperty.CURRENCY]: storefront.currency,
        [constants_1.EventProperty.USER_ID]: session.userID,
        [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
        [constants_1.EventProperty.SESSION_ID]: session.sessionID,
        ...cartProps,
    };
    window.analytics.page(constants_1.EventName.STOREFRONT_VISITED, props);
};
